import { Injectable, signal, computed } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class SharingDataService {

  private readonly _circuitData = signal<any>(false);
  private readonly _changeClick = signal<boolean>(false);
  private readonly _layoutcheck = signal<boolean>(false);
  private readonly _aliasSelected = signal<boolean>(false);
  private readonly _profileDetailsClicked = signal<boolean>(false);
  private readonly _profileShouldOpen = signal<boolean>(false);
  private readonly _penaltyAdded = signal<boolean>(false);
  private readonly _scoreMismatch = signal<boolean>(false);
  private readonly _isProfileSwitched = signal<boolean>(false);
  private readonly _isProfileSelected = signal<boolean>(false);
  private readonly _isProfileChanged = signal<boolean>(false);
  private readonly _isCarAdded = signal<boolean>(false);
  private readonly _toasterToBeDisplayed = signal<boolean>(false);
  private readonly _carAddedSuccessfully = signal<boolean>(false);
  private readonly _mobileMenuVisibility = signal<boolean>(false);

  readonly circuitData = computed(() => this._circuitData());
  readonly changeClick = computed(() => this._changeClick());
  readonly layoutcheck = computed(() => this._layoutcheck());
  readonly aliasSelected = computed(() => this._aliasSelected());
  readonly profileDetailsClicked = computed(() => this._profileDetailsClicked());
  readonly profileShouldOpen = computed(() => this._profileShouldOpen());
  readonly penaltyAdded = computed(() => this._penaltyAdded());
  readonly scoreMismatch = computed(() => this._scoreMismatch());
  readonly mobileMenuVisibility = computed(() => this._mobileMenuVisibility());

  // Pre-built observables — created at field-init time (injection context) so
  // callers can safely subscribe from ngOnInit or any other lifecycle hook.
  readonly mobileMenuStatus$ = toObservable(this._mobileMenuVisibility);
  readonly circuitName$ = toObservable(this._circuitData);
  readonly changeClicked$ = toObservable(this._changeClick);
  readonly layoutCheck$ = toObservable(this._layoutcheck);
  readonly aliasList$ = toObservable(this._aliasSelected);
  readonly profileDetailsClicked$ = toObservable(this._profileDetailsClicked);
  readonly profileOpen$ = toObservable(this._profileShouldOpen);
  readonly penaltyAdded$ = toObservable(this._penaltyAdded);
  readonly scoreMatchCheck$ = toObservable(this._scoreMismatch);
  readonly profileSwitched$ = toObservable(this._isProfileSwitched);
  readonly profileSelected$ = toObservable(this._isProfileSelected);
  readonly profileChanged$ = toObservable(this._isProfileChanged);
  readonly carAdded$ = toObservable(this._isCarAdded);
  readonly toasterToBeDisplayed$ = toObservable(this._toasterToBeDisplayed);
  readonly carAddedSuccessfully$ = toObservable(this._carAddedSuccessfully);

  setMobileMenuStatus(status: boolean) {
    this._mobileMenuVisibility.set(status);
  }

  getMobileMenuStatus() {
    return this.mobileMenuStatus$;
  }

  setCircuitName(data: any) {
    this._circuitData.set(data);
  }

  getCircuitName() {
    return this.circuitName$;
  }

  setChangeClicked(isBoolean: boolean) {
    this._changeClick.set(isBoolean);
  }

  getChangeClicked() {
    return this.changeClicked$;
  }

  setLayoutCheck(isBoolean: boolean) {
    this._layoutcheck.set(isBoolean);
  }

  getLayoutCheck() {
    return this.layoutCheck$;
  }

  setAliasList(isBoolean: boolean) {
    this._aliasSelected.set(isBoolean);
  }

  getAliasList() {
    return this.aliasList$;
  }

  setProfileDetailsClicked(isBoolean: boolean) {
    this._profileDetailsClicked.set(isBoolean);
  }

  getProfileDetailsClicked() {
    return this.profileDetailsClicked$;
  }

  setProfileOpen(isBoolean: boolean) {
    this._profileShouldOpen.set(isBoolean);
  }

  getProfileOpen() {
    return this.profileOpen$;
  }

  setPenaltyAdded(isBoolean: boolean) {
    this._penaltyAdded.set(isBoolean);
  }

  getPenaltyAdded() {
    return this.penaltyAdded$;
  }

  setScoreMatchCheck(isBoolean: boolean) {
    this._scoreMismatch.set(isBoolean);
  }

  getScoreMatchCheck() {
    return this.scoreMatchCheck$;
  }

  setProfileSwitched(isBoolean: boolean) {
    this._isProfileSwitched.set(isBoolean);
  }

  getProfileSwitched() {
    return this.profileSwitched$;
  }

  setProfileSelected(isBoolean: boolean) {
    this._isProfileSelected.set(isBoolean);
  }

  getProfileSelected() {
    return this.profileSelected$;
  }

  setProfileChanged(isBoolean: boolean) {
    this._isProfileChanged.set(isBoolean);
  }

  getProfileChanged() {
    return this.profileChanged$;
  }

  setCarAdded(isBoolean: boolean) {
    this._isCarAdded.set(isBoolean);
  }

  getCardAdded() {
    return this.carAdded$;
  }

  setToasterToBeDisplayed(isBoolean: boolean) {
    this._toasterToBeDisplayed.set(isBoolean);
  }

  getToasterToBeDisplayed() {
    return this.toasterToBeDisplayed$;
  }

  setCarAddedSuccessfully(isBoolean: boolean) {
    this._carAddedSuccessfully.set(isBoolean);
  }

  getCarAddedSuccessfully() {
    return this.carAddedSuccessfully$;
  }
}

